import { Link } from "@tanstack/react-router";
import { create } from "zustand";

import { Button } from "@/components/button";
import {
  Dialog,
  DialogBody,
  DialogCloseButton,
  DialogFooter,
  DialogHeader,
} from "@/components/dialog";
import { Modal } from "@/components/modal";

type RestoreFilesDialogState = {
  isOpen: boolean;
  toggle: () => void;
};
export const useRestoreFilesDialogState = create<RestoreFilesDialogState>()(
  (set) => ({
    isOpen: false,
    toggle: () => set((state) => ({ isOpen: !state.isOpen })),
  }),
);
export function FileRestoredDialog() {
  const { isOpen, toggle } = useRestoreFilesDialogState();

  return (
    <Modal
      classNames={{ modal: "w-[400px]" }}
      isDismissable={false}
      isOpen={isOpen}
    >
      <Dialog alert>
        <DialogHeader className="flex flex-col gap-[16px]">
          File restored!
        </DialogHeader>
        <DialogCloseButton onPress={toggle} />
        <DialogBody className="pt-[4px]">
          <span className="text-sm text-text-tertiary ">
            The file(s) has been restored to its original location.
          </span>
        </DialogBody>
        <DialogFooter className="flex gap-lg">
          <Button asChild color="gray" variant="secondary">
            <Link
              className="flex-1"
              onClick={toggle}
              search={(prev) => ({
                projectId: prev.projectId,
              })}
              to="/my-files"
            >
              Back to My Files
            </Link>
          </Button>
          <Button asChild>
            <Link
              className="flex-1"
              onClick={toggle}
              search={(prev) => ({
                ...prev,
                folder: undefined,
              })}
              to="/my-files"
            >
              View request folder
            </Link>
          </Button>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
